<template>
  <div>
    <Header></Header>
    <div class="power contain_main">
      <div class="sheader">
        <Title title="权限控制"></Title>
        <Button type="primary" @click="$router.go(-1)">返回</Button>
      </div>
      <div class="content" v-for="(item, index) in dataset" :key="'checkall'+index">
        <div class="title">
          <CheckboxGroup v-model="checkedAll" @on-change="handleCheckAllChange">
            <Checkbox :label="index" style="font-weight:bold;">{{item.title}}</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="items">
          <CheckboxGroup v-model="checked" @on-change="handleChange">
            <Checkbox
              style="margin-top:10px"
              v-for="city in item.child"
              :label="city.id"
              :key="city.id"
            >{{city.title}}</Checkbox>
          </CheckboxGroup>
        </div>
      </div>
      <div class="bottom">
        <Button @click="setdata()" type="primary" style="width:200px">保存</Button>
      </div>
    </div>
    <div style="height:200px"></div>
  </div>
</template>
<script>
import { Auths_updateRule, Auths_getRule } from "../../assets/js/api.js";
import Header from "../../components/header";
import Title from "../../components/title";
export default {
  name: "page2",
  data() {
    return {
      dataset: [],
      checked: [],
      checkedAll: [],
      map: Map,
      oldcheckedAll: [],
    };
  },
  components: {
    Header,
    Title
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      Auths_getRule({ id: this.$route.query.id }).then(res => {
        this.checked = [];
        var _this = this;
        if (res.data.code == 200) {
          this.dataset = res.data.data;
          var map = new Map();
          this.dataset.forEach((item, index) => {
            var value = [];
            if (item.check == 1) {
              _this.checkedAll.push(item.id);
            }
            item.child.forEach(e => {
              value.push(e.id);
              if (e.check == 1) {
                _this.checked.push(e.id);
              }
            });
            map.set(index, value);
          });
          this.map = map;
          this.handleChange();
        } else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    },
    setdata() {
      Auths_updateRule({
        id: this.$route.query.id,
        rules: this.checked.concat(this.checkedAll).join(",")
      }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "保存成功！" });
          this.getdata();
        } else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    },
    handleCheckAllChange(value) {
      this.checked = []
      this.checkedAll.forEach(item => {
          this.checked.push(...this.map.get(item));
      });
    },
    handleChange() {
      this.checkedAll = [];
      var _this = this;
      this.map.forEach((value, key, map) => {
        var check = true;
        value.forEach((item, index) => {
          if (_this.checked.indexOf(item) == -1) {
            check = false;
            return;
          }
        });
        if (check) {
          _this.checkedAll.push(key);
        }
      });
      console.log( this.checkedAll )
    }
  }
};
</script>
<style lang="css" scoped>
.power {
  text-align: left;
}
.sheader {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 40px;
}
.content .title {
  border-bottom: 1px solid #eee;
  font-size: 18px;
  line-height: 30px;
}
.content {
  margin: 10px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
}
.items {
  margin-top: 10px;
}
.content:first-child {
  margin-top: 0;
}
.bottom {
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// src/pages/system/powerset.vue